///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';
import { GtthNodeFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-node-feature-dto.model';
import { GtthModifyUnitInfoCommand } from './modify-unit-info-command';

export class GtthChangeLayerMultipleUnitsCommand extends GtthAbstractCommand {
    private terminalIds: number[];
    private newLayerIndex: number;

    private terminalUnitsToChange: GtthNodeFeatureDtoModel[];
    private originalTerminalUnits: GtthNodeFeatureDtoModel[];

    getCommandName(): string {
        return 'GtthChangeLayerMultipleUnitsCommand';
    }

    create(terminalIds: number[], layerIdx: number) {
        this.terminalIds = terminalIds;
        this.newLayerIndex = layerIdx;
        return this;
    }

    doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const logicalTopology = this.historyService.logicalTopology;

        if (!this.terminalIds) {
            this.terminalIds = [];

            for (const station of this.historyService.logicalTopology.getSelectedStations()) {
                this.terminalIds.push(station.getId());
            }
        }

        this.terminalUnitsToChange = [];
        this.originalTerminalUnits = [];

        this.terminalIds.forEach((entityId: number) => {
            const terminalStation = logicalTopology.getStation(entityId);

            if (!terminalStation.hasFreezeLinks()) {
                const terminalGeoJson = terminalStation.toGeoJson();
                this.originalTerminalUnits.push({ ...terminalGeoJson } as GtthNodeFeatureDtoModel);
                terminalGeoJson.setLayerIndex(this.newLayerIndex);
                this.terminalUnitsToChange.push(terminalGeoJson);
            }
        });

        const activity = this.createActivityDTO(false);
        activity.nodes = [...this.terminalUnitsToChange];
        this.sendActivity(activity);
    }

    undoCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const activity = this.createActivityDTO(false);
        activity.nodes = [...this.originalTerminalUnits];
        this.sendActivity(activity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        this.handleCommandActivity(activityDto);
    }

    undoCommandActivity(activityDto: ActivityDTO): void {
        this.handleCommandActivity(activityDto);
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isModifyTopology(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        return true;
    }

    private handleCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            this.historyService.notificationService.showError(activityDto?.error?.message);
            if (this.terminalUnitsToChange) {
                console.log('Command failed:', activityDto.error);
            }
        } else {
            activityDto.nodes.forEach((terminalGeoJson: GtthNodeFeatureDtoModel) => {
                const unitModifyCommand = this.historyService.command(GtthModifyUnitInfoCommand).create(terminalGeoJson.getId());
                unitModifyCommand.setNewLayerIndex(terminalGeoJson.getLayerIndex());
                this.historyService.doCommandBypassHistory(unitModifyCommand, true);
            });
        }

        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.hide()
        });

        if (this.commandResolve) {
            this.commandResolve(activityDto.successful);
        }
    }
}
